import { Box, Typography } from "@mui/material"
import Image from "../../Image"
import profile from "../../../assets/images/profile.png"
import { useAuth } from "../../../contexts/AuthContext";
import LanguageSwitcher from "../../../locales/LanguageSwitcher";

const AppMenu = () => {
    const { auth } = useAuth();
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1, justifyContent: "flex-end" }}>
            <LanguageSwitcher />
            <Image src={profile} style={{ height: '42px', width: '42px', borderRadius: '50%', backgroundColor: '#CCCCCC' }} />
            <Box sx={{ flexDirection: 'column', display: { xs: "none", md: "flex" } }}>
                <Typography display="flex" alignItems="center" gap={"10px"} fontSize="16px" color="#2AB1BF" fontWeight="500">{`${auth?.userDetails?.username || ""}` || `${auth?.userDetails?.firstName || ""} ${auth?.userDetails?.lastName || ""}`}</Typography>
                <Typography fontSize="12px" color="#90909A" fontWeight="400">{auth?.userDetails?.role}</Typography>
            </Box>
        </Box>
    )
}

export default AppMenu